module.exports = __webpack_public_path__ + "assets/img/30-m.2ae754d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/30-m.jpg
// module id = +0wG
// module chunks = 0